

export class VehicleTypeIdDataInput implements IVehicleTypeIdDataInput {
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId!: number;

    constructor(data?: IVehicleTypeIdDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
        }
    }

    static fromJS(data: any): VehicleTypeIdDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeIdDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        return data; 
    }
}

export interface IVehicleTypeIdDataInput {
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId: number;
}

